import {
  _measureTextWidth,
  _getPxStyle
} from './utils';

/**
 * 让input自动扩展宽度，从而能够完整显示placeholder
 * @example <el-input v-entire-placeholder></el-input>
 */
export default {
  // eslint-disable-next-line no-unused-vars
  inserted (el, binding, vnode) {
    let ipts = el.querySelectorAll('input');
    if (!ipts) return;

    let ipt = Array.prototype.filter.call(ipts, ele => ele.parentNode === el);
    if (!ipt.length) return;

    ipt = ipt[0];
    const ph = ipt.getAttribute('placeholder');
    const w = _measureTextWidth(ph);

    const currW = ipt.getBoundingClientRect().width;
    let padL = _getPxStyle(ipt, 'paddingLeft');
    let padR = _getPxStyle(ipt, 'paddingRight');
    padL = padL === null ? 10 : padL;
    padR = padR === null ? 10 : padR;
    if (currW < w) {
      ipt.style.width = `${w + padL + padR + 5}px`;
    }
    ipt = null;
    ipts = null;
  }
};



// WEBPACK FOOTER //
// ./src/directives/entirePlaceholder.js